export default __webpack_public_path__ + "static/10-largest-music-festivals-around-the-globe-7a504fe24b71d97f9137461dd591bd8d.jpg";